<script setup>
import { Loc } from 'main.core';
</script>

<template>
  <h4 class="cloud-calculator__summary-subtitle">
    {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_CALCULATION_TITLE') }}
  </h4>
</template>
